import TextTooltip from './TextTooltip';

interface ImpressionsTooltipProps {
  popoverRef: React.RefObject<HTMLDivElement>;
}

/**
 * This is the total impressions tooltip component.
 * It is used to display the total impressions tooltip.
 *
 * @param popoverRef - The popover ref.
 */
export const TotalImpressionsTooltip = ({ popoverRef }: ImpressionsTooltipProps) => {
  return (
    <TextTooltip
      popoverRef={popoverRef}
      title="Total impressions for impression-based campaigns"
      description="This total includes only impressions delivered for campaigns paid on an impression basis. It does not include campaigns with other payment models."
      buttonText="Impressions"
    />
  );
};

/**
 * This is the impressions not applicable tooltip component.
 * It is used to display the impressions not applicable tooltip.
 *
 * @param popoverRef - The popover ref.
 */
export const ImpressionsNotApplicableTooltip = ({ popoverRef }: ImpressionsTooltipProps) => {
  return (
    <TextTooltip
      popoverRef={popoverRef}
      title="Not applicable"
      description="Earnings are not calculated based on impressions for this campaign type."
      buttonText="n/a"
    />
  );
};
